import React, { useEffect, useState } from "react";
import { FaBook, FaDatabase, FaMoneyBillWave, FaStore } from "react-icons/fa";
import { Link } from "react-router-dom";
import { AiFillDashboard } from "react-icons/ai";
import Cookies from "js-cookie";
import Sidebar from "./Sidebar";
import { AWS_URL } from "../../Constant";

// import { isTokenExpired, logoutUser } from "../../utlis/authUtils";
import { logoutUser } from "../../utlis/authUtils";

const Dashboard = () => {
  const [userData, setUserData] = useState("");
const fetchData = async () => {
    const jwtToken = Cookies.get("jwt_token");
    if (!jwtToken) {
      alert("Your session has expired. Please log in again.");
      logoutUser();
      return;
    }

    const url = `${AWS_URL}/userData`;
    const option = {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${jwtToken}`,
      },
    };
    try {
      const response = await fetch(url, option);
      if (response.status === 200) {
        const data = await response.json();
        setUserData(data);
      }
    } catch (error) {
}
  };

  const checkUsertype = () => {
    if (userData && userData.usertype === "boss") {
      // boss dashboard logic here
    } else if (userData && userData.usertype === "subadmin") {
      // subadmin dashboard logic
    }
  };

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <>
      <Sidebar>
        <div className="w-full   ">
          <div className="flex justify-center h-full ">
            <div>
              <div className="flex flex-wrap items-center justify-center sm:justify-start gap-x-4 gap-y-1 bg-white rounded-lg shadow-sm p-2 sm:p-3 text-sm sm:text-base">
                <span>
                  <span className="text-rose-700 font-semibold">Store:</span>{" "}
                  <span className="text-blue-600 font-medium">
                    {userData?.storename || "-"}
                  </span>
                </span>
                <span>
                  <span className="text-rose-700 font-semibold">Name:</span>{" "}
                  <span className="text-blue-600 font-medium">
                    {userData?.name || "-"}
                  </span>
                </span>
                <span>
                  <span className="text-rose-700 font-semibold">EmpID:</span>{" "}
                  <span className="text-blue-600 font-medium">
                    {userData?.empid || "-"}
                  </span>
                </span>
              </div>

              <div className="flex text-lg bg-gray-300 w-40 p-2 ml-2 items-center mt-2 gap-2 rounded-xl justify-center">
                <AiFillDashboard className="text-[#2c4372]" />
                <h1 className=" cursor-pointer">Dashboard</h1>
              </div>
              <div className=" p-2 flex items-center justify-start flex-wrap gap-5 mt-4">
                <Link to={"/billing"}>
                  <div className="flex text-white m-2 justify-between p-3 rounded-lg bg-gradient-to-r from-[#f86d57] to-[#f12a5f]  shadow-lg w-[229px] shadow-gray-400 h-20">
                    <button className="text-xl font-semibold">Billing</button>
                    <FaMoneyBillWave size={30} className=" cursor-pointer" />
                  </div>
                </Link>
                <Link to={"/sales"}>
                  <div className="flex  m-2 justify-between p-3 rounded-lg bg-gradient-to-r from-[#49d6d1] to-[#08aace] shadow-lg w-[228px] shadow-gray-400 h-20">
                    <button className="text-xl font-semibold">
                      Sales Reports
                    </button>
                    <FaStore size={30} className=" cursor-pointer text-white" />
                  </div>
                </Link>
                <Link to={"/product"}>
                  <div className="flex text-white m-2 justify-between p-3 rounded-lg bg-gradient-to-r from-[#519be0] to-[#2f3be7] shadow-lg w-[228px] shadow-gray-400 h-20">
                    <button className="text-xl font-semibold">
                      Add Products
                    </button>
                    <FaDatabase size={30} className=" cursor-pointer" />
                  </div>
                </Link>
                <Link to={"/stocks"}>
                  <div className="flex text-white m-2 justify-between p-3 rounded-lg bg-gradient-to-r from-[#c853df] to-[#5f12f8] shadow-lg w-[228px] shadow-gray-400 h-20">
                    <button className="text-xl font-semibold">Stocks</button>
                    <FaBook size={30} className=" cursor-pointer" />
                  </div>
                </Link>
                <Link to={"/stocksshort"}>
                  <div className="flex text-white m-2 justify-between p-3 rounded-lg bg-gradient-to-r from-[#727370] to-[#147b3b] shadow-lg w-[228px] shadow-gray-400 h-20">
                    <button className="text-xl font-semibold">
                      Shortage_Stocks
                    </button>
                    <FaDatabase size={30} className=" cursor-pointer" />
                  </div>
                </Link>
                {/* <Link to={"/attendancereport"}>
                  <div className="flex text-white m-2 justify-between p-3 rounded-lg bg-gradient-to-r from-[#c853df] to-[#f12a5f] shadow-lg w-[228px] shadow-gray-400 h-20">
                    <button className="text-xl font-semibold">
                      Attendance Report
                    </button>
                    <FaDatabase size={30} className=" cursor-pointer" />
                  </div>
                </Link> */}
                <Link to={"/addexpenses"}>
                  <div className="flex text-white m-2 justify-between p-3 rounded-lg bg-gradient-to-r from-[#727370] to-[#f12a5f] shadow-lg w-[228px] shadow-gray-400 h-20">
                    <button className="text-xl font-semibold">
                      Add Expenses
                    </button>
                    <FaDatabase size={30} className=" cursor-pointer" />
                  </div>
                </Link>
                <Link to={"/expenses"}>
                  <div className="flex text-white m-2 justify-between p-3 rounded-lg bg-gradient-to-r from-[#c853df] to-[#f12a5f] shadow-lg w-[228px] shadow-gray-400 h-20">
                    <button className="text-xl font-semibold">Expenses</button>
                    <FaDatabase size={30} className=" cursor-pointer" />
                  </div>
                </Link>
                {/* <Link to={"/services"}>
                  <div className="flex text-white m-2 justify-between p-3 rounded-lg bg-gradient-to-r from-[#094502] to-[#3c419e] shadow-lg w-[228px] shadow-gray-400 h-20">
                    <button className="text-xl font-semibold">Service</button>
                    <FaDatabase size={30} className=" cursor-pointer" />
                  </div>
                </Link> */}
{/* <div className="flex text-white m-2 justify-between p-3 rounded-lg bg-gradient-to-r from-[#e53232] to-[#f04511] shadow-lg w-[228px] shadow-gray-400 h-20">
                <a
                  href="http://192.168.0.105:3000/login"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="text-xl font-semibold hover:underline cursor-pointer"
                >
                  gplus service
                </a>
                </div> */}

                {userData &&
                  (userData.usertype === "boss" ||
                    userData.usertype === "account") && (
                    <Link to={"/accountexpenses"}>
                      <div className="flex text-white m-2 justify-between p-3 rounded-lg bg-gradient-to-r from-[#c853df] to-[#f12a5f] shadow-lg w-[228px] shadow-gray-400 h-20">
                        <button className="text-xl font-semibold">
                          All Branche Expenses
                        </button>
                        <FaDatabase size={30} className=" cursor-pointer" />
                      </div>
                    </Link>
                  )}
                {userData &&
                  (userData.usertype === "boss" ||
                    userData.usertype === "hr") && (
                    <Link to={"/hrattendancereport"}>
                      <div className="flex text-white m-2 justify-between p-3 rounded-lg bg-gradient-to-r from-[#6614eb] to-[#f12a5f] shadow-lg w-[228px] shadow-gray-400 h-20">
                        <button className="text-xl font-semibold">
                          All Employee Attendance
                        </button>
                        <FaDatabase size={30} className=" cursor-pointer" />
                      </div>
                    </Link>
                  )}

                {userData && userData.usertype === "boss" && (
                  <Link to={"/admin"}>
                    <div className="flex text-white m-2 justify-between p-3 rounded-lg bg-gradient-to-r from-[#703de4] to-[#ea1405] shadow-lg w-[228px] shadow-gray-400 h-20">
                      <button
                        onClick={checkUsertype}
                        className="text-xl font-semibold"
                      >
                        Admin Dashboard
                      </button>
                      <FaBook size={30} className=" cursor-pointer" />
                    </div>
                  </Link>
                )}

                {userData && userData.usertype === "subadmin" && (
                  <Link to={"/store"}>
                    <div className="flex text-white m-2 justify-between p-3 rounded-lg bg-gradient-to-r from-[#3e3d04] to-[#08aace] shadow-lg w-[228px] shadow-gray-400 h-20">
                      <button
                        onClick={checkUsertype}
                        className="text-xl font-semibold"
                      >
                        Store's Dashboard
                      </button>
                      <FaBook size={30} className=" cursor-pointer" />
                    </div>
                  </Link>
                )}
              </div>
            </div>
          </div>
        </div>
      </Sidebar>
    </>
  );
};

export default Dashboard;
